import { NestedFilter } from '@@partner:types:graphql'

import React, { useCallback, useState } from 'react'
import { generatePath, Link } from 'react-router-dom'
import { useQueryFeedbacks } from '@@partner:graphql/query/feedback/feedbacks.gql'
import { useGridHelper } from '@@partner:helpers/crud/grid'
import { usePartner } from '@@partner:helpers/hooks/auth'

import LegacyListIcon from '@rsuite/icons/legacy/List'

import { Button, ButtonGroup, Panel, Message, Pagination } from 'rsuite'
import GraphQLCommonErrorDisplay from '@components/common/GraphQLCommonErrorDisplay'
import FeedbacksTable from '@components/feedback/grid/FeedbacksTable'
import FeedbacksFilter from '@components/feedback/grid/FeedbacksFilter'
import { SORT_ORDER_DESC } from '@@partner:config/graphql'

import {
  ROUTE_FEEDBACK_VIEW_FEEDBACK,
  ROUTE_ORDERS,
  ROUTE_ORDERS_FEEDBACKS
} from '@@partner:config/routes'
import OrdersPageTopMenu from '@components/order/OrdersPageTopMenu'

export default function OrdersFeedbacksPage () {
  const { brandSlug } = usePartner()
  const [ filter, setFilter ] = useState<NestedFilter>({
    fields: [ 'id' ],
    op: 'unwrap'
  })

  const {
    page,
    limit,
    defaultLimitOptions,
    tableSort,
    handlePageSelect,
    handleLimitSelect,
    handleSortColumn
  } = useGridHelper()

  const { data, loading, error } = useQueryFeedbacks({
    pager: {
      page,
      limit
    },
    sort: {
      fieldName: tableSort.fieldName,
      direction: tableSort.direction
    },
    filter
  })

  const feedbacks = data?.feedbacks.edges ?? []
  const pageInfo = data?.feedbacks.pageInfo

  const showPagination = pageInfo?.lastPage !== 1

  const handleFilterChanged = useCallback(
    (updatedFilter: NestedFilter) => {
      setFilter(updatedFilter)
      handlePageSelect(1)
    },
    [ handlePageSelect ]
  )

  const generateOpenUrl = useCallback(
    (feedbackId) => {
      if (!brandSlug) {
        return ''
      }
      return generatePath(ROUTE_FEEDBACK_VIEW_FEEDBACK, {
        brandSlug,
        feedbackId
      })
    },
    [ brandSlug ]
  )

  if (error) {
    return (
      <GraphQLCommonErrorDisplay
        title="Ошибка загрузки товаров"
        error={error}
      />
    )
  }

  return (
    <div className="OrdersFeedbacksPage">
      <h1 className="u-heading">Отзывы покупателей</h1>
      <OrdersPageTopMenu />

      <FeedbacksFilter onFilterChanged={handleFilterChanged} />

      <Panel shaded>
        {feedbacks && (
          <FeedbacksTable
            loading={loading}
            feedbacks={feedbacks}
            generateOpenUrl={generateOpenUrl}
            sortColumn={tableSort.fieldName}
            sortType={tableSort.direction === SORT_ORDER_DESC ? 'desc' : 'asc'}
            onSortColumn={handleSortColumn}
          />
        )}

        {showPagination && (
          <Pagination
            size="md"
            last
            first
            next
            prev
            ellipsis
            activePage={page}
            pages={pageInfo?.lastPage}
            total={pageInfo?.lastPage ?? 1}
            maxButtons={10}
            onSelect={handlePageSelect}
          />
        )}
      </Panel>
    </div>
  )
}
